import $ from "jquery";

function init(): void {
  const $myLocalAdviser = $(".js-my-local-adviser");

  if ($myLocalAdviser.length) {
    const mlaUri = $myLocalAdviser.data("mla-uri");

    $(document).ready(function () {
      $(".js-search-panel").mlaSearch2({
        hostId: 1,
        mlaUri,

        searchConditionsId: "searchConditions",
        searchResultsId: "searchResults",
        mapPanelId: "mapPanel",
        searchResultTitleId: "searchResultsTitle",
        detailedInfoId: "companyAndAdviserDetails",
        panelTemplate: "SearchConditionsSk.htm",
        resultTemplate: "AdviserPanelSk.htm",
        companyInfoTemplate: "AdviserDetails.htm",
        adviserInfoTemplate: "AdviserPersonDetails.htm",

        quickSearch: true,
      });
    });
  }
}

export default { init };
